import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
    selector: "[mvTypeDirective]",
})
export class TypeDirective implements OnInit {
    @Input("mvTypeDirective") context: string;

    constructor(private el: ElementRef) {}

    ngOnInit() {
        switch (this.context) {
            case "wedding":
                this.el.nativeElement.textContent = "Liste de mariage";
                break;
            case "travel":
                this.el.nativeElement.textContent = "Liste de voyage";
                break;

            default:
                this.el.nativeElement.textContent = "Liste de mariage";
        }
    }
}
